//import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import { gridMargin } from './general';

export default class FMPSelect extends PureComponent {
	render() {
		const {
			label,
			value,
			path,
			onChange,
			readOnly,
			error,
			options,
			helpText,
			md,
			disabled,
			contained,
			multiple,
		} = this.props;

		const _onChange = (event) => {
			onChange(event.target.value, path);
		};

		//- With multiple + rich MenuItem children, MUI joins the children elements
		//- into the input text ("[object Object], ..."), so render the displays ourselves.
		const renderMultipleValue = (selected) => {
			return selected
				.map((selectedValue) => {
					const option = options.find((o) => o.value === selectedValue);
					return option ? option.display : selectedValue;
				})
				.join(', ');
		};

		//let value, onChange, error;
		const hasError = !!error;
		const content = (
			<Grid item xs={12} md={md} style={gridMargin}>
				<FormControl
					fullWidth={true}
					error={hasError}
					disabled={disabled}
					style={{ textAlign: 'left' }}
				>
					<InputLabel htmlFor={path}>{label}</InputLabel>
					<Select
						value={value}
						onChange={_onChange}
						input={<Input name={path} readOnly={readOnly} />}
						// input={<Input name={path} id={path} readOnly={readOnly} />}
						multiple={multiple}
						renderValue={multiple ? renderMultipleValue : undefined}
					>
						{options.map((option) => {
							//- option.disabled / option.subDisplay are optional. Callers that do not
							//- set them behave exactly as before.
							return (
								<MenuItem
									key={option.value}
									value={option.value}
									disabled={!!option.disabled}
								>
									<div>
										<div>{option.display}</div>
										{option.subDisplay && (
											<div style={{ fontSize: 11, opacity: 0.7, whiteSpace: 'normal' }}>
												{option.subDisplay}
											</div>
										)}
									</div>
								</MenuItem>
							);
						})}
					</Select>
					{hasError && <FormHelperText>{error}</FormHelperText>}
					{helpText && !hasError && <FormHelperText>{helpText}</FormHelperText>}
				</FormControl>
			</Grid>
		);

		if (contained) {
			return (
				<Grid spacing={2} container>
					{content}
				</Grid>
			);
		} else {
			return content;
		}
	}
}

FMPSelect.propTypes = {
	label: PropTypes.string.isRequired,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]).isRequired,
	path: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	error: PropTypes.string,

	options: PropTypes.array.isRequired,

	helpText: PropTypes.string,
	contained: PropTypes.bool,
	disabled: PropTypes.bool,
	md: PropTypes.number,
	multiple: PropTypes.bool,
	readOnly: PropTypes.bool,
};

FMPSelect.defaultProps = {
	contained: true,
	multiple: false,
	md: 12,
};
